
$(window).on('load', function(){
    if($('cal-floating-button')[0]){
        const style = $(`<style> 
                    .cal-button-style { 
                        height: 50px;
                        font-size: 1.5rem;
                    } 
                </style>`);
        const shaRoot = $('cal-floating-button')[0].shadowRoot;
        $(shaRoot).append(style);
        const button = $(shaRoot).find('button')[0];
        $(button).addClass('cal-button-style');
    }
});